import { render } from "./ShipmentDetails.vue?vue&type=template&id=7cdf91e8&scoped=true&ts=true"
import script from "./ShipmentDetails.vue?vue&type=script&lang=ts"
export * from "./ShipmentDetails.vue?vue&type=script&lang=ts"

import "./ShipmentDetails.vue?vue&type=style&index=0&id=7cdf91e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cdf91e8"]])

export default __exports__